import React from 'react';

const items = [
  'No-Code Automation','Generative AI Workflows','Video Production',
  'Prompt Engineering','Brand Voice Matching','Content at Scale',
  'AI Strategy','Social Media AI','SEO + AI','Email Automation',
  'Graphics Design','Vibe Coding','Generative UI','Semantic SEO',
];

const ScrollingRibbon = () => {
  const doubled = [...items, ...items];

  return (
    <div style={{
      overflow: 'hidden',
      borderTop: '1px solid rgba(240,236,228,0.07)',
      borderBottom: '1px solid rgba(240,236,228,0.07)',
      background: '#0e0d0b',
      padding: '12px 0',
    }}>
      <div style={{ display: 'flex', animation: 'hx8-marquee 28s linear infinite', width: 'max-content' }}>
        {doubled.map((item, i) => (
          <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 18, padding: '0 28px', whiteSpace: 'nowrap' }}>
            <span style={{ color: '#e8701a', fontFamily: "'DM Mono', monospace", fontSize: 10 }}>◆</span>
            <span style={{
              color: 'rgba(240,236,228,0.35)', fontSize: 12,
              letterSpacing: '0.1em', textTransform: 'uppercase', fontWeight: 500,
              fontFamily: "'Space Grotesk', sans-serif",
            }}>{item}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ScrollingRibbon;
